import React, { useState } from "react";
import { Constants } from "../../Constants";

export const FirstTimeShipperDetails = (props) => {
    const [userHasAcceptedPoaTerms, updateUserChoiceOfPoa] = useState(false);
    const [isNvoccOrOff, updateNvoccOrOff] = useState(false);

    const passportInput = () => 
    <div className="col-md-6 col-sm-8 mt-sm-2">
        <label className="control-label">Foreign Passport #</label>
        <input required name="firstTimeCustomerDetails.passportNumber" className="form-control"/>
        <label className="control-label">Foreign Passport Country</label>
        <select required name="firstTimeCustomerDetails.passportCountry" className="form-select" autoComplete="off">
            {Constants.worldCountriesList.map((val,index) => 
                <option key={index} value={val}>{val}</option>
            )}
        </select>
    </div>;

    const EinInput = () =>
        <div className="col-md-6 col-sm-8 mt-sm-2">
            <label className="control-label">EIN (Tax ID) #</label>
            <input required name="firstTimeCustomerDetails.EIN_TaxID" className="form-control" autoComplete="off"/>
        </div>;      

    const [passportOrEin, updatePassportOrEin] = useState(EinInput);

    return(
        <div className="col-12">
            <div className="row">
                <div className="col-12">
                    <em>First time shippers need to provide a valid residence address and grant us Power of attorney to handle goods during transportation</em>
                </div>
                <div id="First-Time-Info-Card" className="col-sm-12 col-md-6 my-3">
                    <div className="card border border-dark p-2">
                        <div className="display-5 mb-2">Your Address</div>
                        <div className="row">
                            <div className="col-md-12 col-sm-9">
                                <label className="control-label">Full Street Address</label>
                                <input required name="firstTimeCustomerDetails.streetAddress" className="form-control" autoComplete="off"/>
                                <span asp-validation-for="firstTimeCustomerDetails.streetAddress" className="text-danger"></span>
                            </div>
                            <div className="col-md-6 col-sm-9 mt-sm-2">
                                <label className="control-label">City</label>
                                <input required name="firstTimeCustomerDetails.City" className="form-control" autoComplete="off"/>
                                <span asp-validation-for="firstTimeCustomerDetails.City" className="text-danger"></span>
                            </div>
                            <div className="col-md-6 col-sm-8 mt-sm-2">
                                <label className="control-label">State</label>
                                <input required name="firstTimeCustomerDetails.State" className="form-control" autoComplete="off"/>
                                <span asp-validation-for="firstTimeCustomerDetails.State" className="text-danger"></span>
                            </div>
                            <div className="col-md-6 col-sm-8 mt-sm-2">
                                <label className="control-label">ZIP Code</label>
                                <input name="firstTimeCustomerDetails.ZIPCode" className="form-control" autoComplete="off"/>
                                <span asp-validation-for="firstTimeCustomerDetails.ZIPCode" className="text-danger"></span>        
                            </div>
                            <div className="col-md-6 col-sm-8 mt-sm-2">
                                <label className="control-label">Country</label>
                                <select required name="firstTimeCustomerDetails.Country" className="form-select" autoComplete="off">
                                    {Constants.worldCountriesList.map((val,index) => 
                                        <option key={index} value={val}>{val}</option>
                                    )}
                                </select>
                            </div>                   
                        </div>
                    </div>
                    <div className="mt-sm-2">
                        <strong className="mr-2">I am a</strong>
                        <span className="form-check mb-1">
                            <input type="radio" className="form-check-input"
                                id="Entity-Type-Individual" name="firstTimeCustomerDetails.entityType" value={Constants.firstTimeShipperEntity_IndividualShipper}
                                defaultChecked={true}
                                onClick={() => updateNvoccOrOff(false) }/>
                            <label className="form-check-label" htmlFor="Entity-Type-Individual">
                                Individual Shipper
                            </label>
                        </span>
                        <div className="form-check my-1">
                            <input type="radio" className="form-check-input"
                                id="Entity-Type-Business-Nvocc" name="firstTimeCustomerDetails.entityType" value={Constants.firstTimeShipperEntity_NVOCC}
                                onClick={() => updateNvoccOrOff(true) }/>
                            <label className="form-check-label" htmlFor="Entity-Type-Business-Nvocc">
                                Business (NVOCC)
                            </label>
                        </div>
                        <div className="form-check form-check-inline my-1">
                            <input type="radio" className="form-check-input"
                                id="Entity-Type-Business-Off" name="firstTimeCustomerDetails.entityType" value={Constants.firstTimeShipperEntity_FreightForwarder}
                                onClick={() => updateNvoccOrOff(true) }/>
                            <label className="form-check-label" htmlFor="Entity-Type-Business-Off">
                                Business (Freight forwarder)
                            </label>
                        </div>
                        {isNvoccOrOff && <div className="col-12 col-md-6">
                            <label className="control-label">FMC #</label>
                            <input required type="text" name="firstTimeCustomerDetails.fmcNumber" className="form-control"/>
                        </div>}
                    </div>
                    <div className="mt-sm-2">
                        <strong className="mr-2">Please provide one</strong>
                        <span className="form-check mb-1">
                            <input type="radio" className="form-check-input"
                                id="EIN-Input" name="firstTimeCustomerDetails.passportOrEin" value="EIN Input"
                                defaultChecked={true} 
                                onClick={() => updatePassportOrEin(EinInput) }/>
                            <label className="form-check-label" htmlFor="EIN-Input">
                                EIN (Federal Tax ID) Number
                            </label>
                        </span>
                        <div className="form-check form-check-inline my-1">
                            <input type="radio" className="form-check-input"
                                id="Passport-Input" name="firstTimeCustomerDetails.passportOrEin" value="Passport"
                                onClick={() => updatePassportOrEin(passportInput) }/>
                            <label className="form-check-label" htmlFor="Passport-Input">
                                Foreign Passport Number
                            </label>
                        </div>
                    </div>
                    <div className="row">
                        {passportOrEin}
                    </div>
                </div>
                {/* <div className="col-sm-12 col-md-6 my-3">
                    Carefully read, fill out, and send us the following Power of attorney document. This document permits us to handle your cargo during the shipping process
                    <a href="https://angelicshipping.com/AngelicStaticFiles/shipping/POWER%20OF%20ATTORNEY.pdf" 
                        className="btn btn-primary btn-lg mx-auto my-auto" target="_blank" rel="noopener noreferrer">
                        Power of attorney
                    </a>
                </div> */}
                <div id="Power-Of-Attorney-Card" className="col-sm-12 col-md-6 my-3">
                    <div className="card border border-dark p-2" style={{"min-height": "320px"}}>
                        <div className="h5 mb-2 text-center">Export Power of Attorney</div>
                        <div className="p-1"> {/*style={{"overflow":"scroll"}}*/}
                            <strong>To: U.S. Customs &amp; Border Protection</strong><br />
                            <strong>Re: Exportation of Cargo from the United States</strong><br />
                            I, the customer, hereby authorize Angelic Solution Spot, Inc. (A.S.S) &amp; their employees:
                            <ul>
                                <li>To act as my forwarding agent for the export control and customs purposes.</li>
                                <li>To prepare, sign, declare or swear to any Shipper’s Export Declaration required by law or regulations in connection with the exportation of any commodity shipped by me, the customer.</li> 
                                <li>To do all the things necessary to ensure compliance with all requirements pursuant to section
                                    &nbsp;<a target="_blank"
                                        rel="noopener noreferrer" href="https://www.govinfo.gov/app/details/CFR-2011-title19-vol2/CFR-2011-title19-vol2-part192">19 CFR Part 192</a> 
                                    &nbsp;of the U.S. Customs regulations:</li>
                            </ul>                            
                            <em>Angelic Solution Spot Inc. 9244 E Hampton Drive, Capitol Heights, MD 20743 FMC # 027284N <br />Tel: (240) 563-1951 Fax: 240-455-6328 <a target="_blank"
                                rel="noopener noreferrer" href="https://www.angelicshipping.com">www.angelicshipping.com</a></em>
                        </div>
                        <div className="col-12 col-md-6 my-2">
                            <label className="control-label">Signature</label>
                            <input required type="text" name="firstTimeCustomerDetails.signature" className="form-control"/>
                        </div>
                        <div className="form-check my-1">
                            <input required type="checkbox" className="form-check-input" id="Poa-Agreement" onChange={(evt) => props.onChange(evt.target.value)}/>
                            <label className="form-check-label" htmlFor="Poa-Agreement"><strong>By checking this box, you confirm that you have read the power of attorney document in its entirety and agree to its terms</strong></label>
                            <span className="text-muted">*We retain your residence, FMC license #, and other details along with your signature for our records</span>
                        </div>
                    </div>
                    
                </div>
                <div className="col-12">
                    <hr />
                </div>
            </div>
        </div>
    );

}